<template>
  <QBtn
    flat
    round
    :size="size"
    v-bind="$attrs"
    v-on="$listeners"
    :icon="icon"
    :text-color="color"
  />
</template>

<script>
import { QBtn } from 'quasar';

export default {
  name: 'SAIIconBtn',
  props: {
    icon: {
      type: String,
      default: 'eva-close-outline'
    },
    size: {
      type: String,
      default: 'sm'
    },
    color: {
      type: String,
      default: 'grey-8'
    }
  },
  components: {
    QBtn
  }
};
</script>
